// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessage = require("../common/Components/SystemMessage.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AccountMemberUtils = require("./AccountMemberUtils.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SubuserMemberEditForm_member_graphql = require("../../__generated__/SubuserMemberEditForm_member_graphql.bs.js");
let SubuserMemberEditForm_UpdateMemberV5Mutation_graphql = require("../../__generated__/SubuserMemberEditForm_UpdateMemberV5Mutation_graphql.bs.js");

let validators = {
  role: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: param => {
      let role = param.role;
      if (role !== undefined) {
        return {
          TAG: "Ok",
          _0: role
        };
      } else {
        return {
          TAG: "Error",
          _0: "is required"
        };
      }
    }
  }
};

function initialFieldsStatuses(input) {
  return {
    role: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    role: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      role: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.role;
  let match$1;
  match$1 = typeof match !== "object" ? validators.role.validate(input) : match._0;
  if (match$1.TAG === "Ok") {
    return {
      TAG: "Valid",
      output: {
        role: match$1._0
      },
      fieldsStatuses: {
        role: {
          TAG: "Dirty",
          _0: match$1,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  } else {
    return {
      TAG: "Invalid",
      fieldsStatuses: {
        role: {
          TAG: "Dirty",
          _0: match$1,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  }
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurRoleField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.role, validators.role, status => ({
            role: status
          }));
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateRoleField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.role, state.submissionStatus, validators.role, status => ({
                role: status
              })),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  role: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  role: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateRole: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateRoleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurRole: () => dispatch("BlurRoleField"),
    roleResult: Formality.exposeFieldResult(state.fieldsStatuses.role),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.role;
      return typeof tmp === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let accountMemberRole_decode = SubuserMemberEditForm_member_graphql.Utils.accountMemberRole_decode;

let convertFragment = SubuserMemberEditForm_member_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubuserMemberEditForm_member_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SubuserMemberEditForm_member_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubuserMemberEditForm_member_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubuserMemberEditForm_member_graphql.node, convertFragment, fRef);
}

let MemberFragment_accountMemberRole_fromString = SubuserMemberEditForm_member_graphql.Utils.accountMemberRole_fromString;

let MemberFragment = {
  accountMemberRole_decode: accountMemberRole_decode,
  accountMemberRole_fromString: MemberFragment_accountMemberRole_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = SubuserMemberEditForm_UpdateMemberV5Mutation_graphql.Internal.convertVariables;

let convertResponse = SubuserMemberEditForm_UpdateMemberV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = SubuserMemberEditForm_UpdateMemberV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SubuserMemberEditForm_UpdateMemberV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, SubuserMemberEditForm_UpdateMemberV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateMemberV5Mutation_accountMemberRoleInput_decode = SubuserMemberEditForm_UpdateMemberV5Mutation_graphql.Utils.accountMemberRoleInput_decode;

let UpdateMemberV5Mutation_accountMemberRoleInput_fromString = SubuserMemberEditForm_UpdateMemberV5Mutation_graphql.Utils.accountMemberRoleInput_fromString;

let UpdateMemberV5Mutation = {
  accountMemberRoleInput_decode: UpdateMemberV5Mutation_accountMemberRoleInput_decode,
  accountMemberRoleInput_fromString: UpdateMemberV5Mutation_accountMemberRoleInput_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function SubuserMemberEditForm(props) {
  let onClose = props.onClose;
  let member = RescriptRelay_Fragment.useFragment(SubuserMemberEditForm_member_graphql.node, convertFragment, props.member);
  let match = use$1();
  let updateMember = match[0];
  let form = useForm({
    role: Stdlib_Option.flatMap(Stdlib_Option.flatMap(member.role, v => accountMemberRole_decode(v)), role => {
      switch (role) {
        case "ASSISTANT" :
          return "ASSISTANT";
        case "ASSOCIATE" :
          return "ASSOCIATE";
        case "BUYER_SPECIALIST" :
          return "BUYER_SPECIALIST";
        case "CLIENT_CARE_COORDINATOR" :
          return "CLIENT_CARE_COORDINATOR";
        case "INSIDE_SALES_AGENT" :
          return "INSIDE_SALES_AGENT";
        case "LISTING_MANAGER" :
          return "LISTING_MANAGER";
        case "LISTING_SPECIALIST" :
          return "LISTING_SPECIALIST";
        case "MARKETING_SPECIALIST" :
          return "MARKETING_SPECIALIST";
        case "OPERATIONS_MANAGER" :
          return "OPERATIONS_MANAGER";
        case "PARTNER" :
          return "PARTNER";
        case "SHOWING_ASSISTANT" :
          return "SHOWING_ASSISTANT";
        case "TRANSACTION_COORDINATOR" :
          return "TRANSACTION_COORDINATOR";
        case "OWNER" :
        case "UNKNOWN" :
          return;
      }
    })
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    updateMember({
      input: {
        id: member.id,
        role: param.role
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let updateMemberV5 = param.updateMemberV5;
      if (updateMemberV5 === undefined) {
        return notifyOnFailure("Error updating data. Please refresh and try again...");
      }
      switch (updateMemberV5.__typename) {
        case "AccountMemberUpdated" :
          return notifyOnSuccess(undefined);
        case "SubuserInvitationFailed" :
          return notifyOnFailure(updateMemberV5.message);
        case "__unselected" :
          return notifyOnFailure("Error updating data. Please refresh and try again...");
      }
    }, undefined, undefined);
  });
  let message = form.status;
  let tmp;
  tmp = typeof message !== "object" ? (
      message === "Editing" ? null : JsxRuntime.jsx(SystemMessage.make, {
          id: "form_submitted",
          time: 5000,
          text: "Account updated",
          type_: "success",
          dismissible: true,
          secondary: true,
          handleOnDismiss: param => {
            form.reset();
            onClose();
          }
        })
    ) : (
      message.TAG === "Submitting" ? null : JsxRuntime.jsx(SystemMessage.make, {
          id: "form_submitted",
          time: 5000,
          text: message._0,
          type_: "error",
          dismissible: true,
          secondary: true,
          handleOnDismiss: param => form.dismissSubmissionResult()
        })
    );
  let match$1 = form.roleResult;
  let tmp$1;
  tmp$1 = match$1 !== undefined ? (
      match$1.TAG === "Ok" ? "Ok" : "Error"
    ) : undefined;
  return JsxRuntime.jsxs("div", {
    children: [
      tmp,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: "First name",
              className: "font-semibold"
            }),
            className: "col-span-1"
          }),
          JsxRuntime.jsx("div", {
            children: Stdlib_Option.getOr(member.agent.firstName, ""),
            className: "col-span-3"
          })
        ],
        className: "grid grid-cols-4 gap-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: "Last name",
              className: "font-semibold"
            }),
            className: "col-span-1"
          }),
          JsxRuntime.jsx("div", {
            children: Stdlib_Option.getOr(member.agent.lastName, ""),
            className: "col-span-3"
          })
        ],
        className: "grid grid-cols-4 gap-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: "Email",
              className: "font-semibold"
            }),
            className: "col-span-1"
          }),
          JsxRuntime.jsx("div", {
            children: Stdlib_Option.getOr(Stdlib_Option.map(member.agent.emailAddress, v => Scalars.EmailAddress.toString(v)), ""),
            className: "col-span-3"
          })
        ],
        className: "grid grid-cols-4 gap-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: "Display name",
              className: "font-semibold"
            }),
            className: "col-span-1"
          }),
          JsxRuntime.jsx("div", {
            children: member.agent.displayName,
            className: "col-span-3"
          })
        ],
        className: "grid grid-cols-4 gap-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: "Role",
              className: "font-semibold"
            }),
            className: "col-span-1"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(AccountMemberUtils.RoleSelectComponent.make, {
                onChange: value => form.updateRole((param, value) => ({
                  role: value
                }), value !== undefined ? value.value : undefined),
                result: tmp$1,
                value: Stdlib_Option.map(form.input.role, v => AccountMemberUtils.SelectOpts.make(v))
              })
            }),
            className: "col-span-3"
          })
        ],
        className: "grid grid-cols-4 gap-4"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              onClick: extra => Form__Helpers.preventDefault(form.submit, extra),
              disabled: match[1] || form.submitting,
              children: "Save"
            }),
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => onClose(),
              children: "Cancel"
            })
          ],
          className: "flex flex-row space-x-2"
        }),
        className: "grid grid-cols-4 gap-4"
      })
    ],
    className: "flex flex-col space-y-4 w-full"
  });
}

let make = SubuserMemberEditForm;

exports.FormConfig = FormConfig;
exports.MemberFragment = MemberFragment;
exports.UpdateMemberV5Mutation = UpdateMemberV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
